import React from "react";
import { ClipboardXIcon, FrownIcon, HourglassIcon, PuzzleIcon, SearchIcon, BatteryLowIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { painPoints, PainIcon } from "../../data/landing";
const iconMap: Record<PainIcon, React.ComponentType<{
  className?: string;
}>> = {
  anxious: FrownIcon,
  clock: HourglassIcon,
  puzzle: PuzzleIcon,
  clipboard: ClipboardXIcon,
  search: SearchIcon,
  tired: BatteryLowIcon
};
export function PainPoints() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-257" data-mp="2ckvpfmtxc2e5">
      <div className="mx-auto max-w-5xl" data-id="element-258" data-mp="2qloie34kupf5">
        <SectionHeading title="Do any of these situations sound familiar?" data-id="element-259" data-mp="2qkdfs6mvbnpm" />
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-260" data-mp="2mkmeh8zptp6u">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.text} className="flex items-start gap-4 rounded-2xl bg-cream p-5" data-id="element-261" data-mp="s5jz444drnhn">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy text-gold" data-id="element-262" data-mp="1n7tn0bwabpe9">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-263" data-mp="1s6d8ycavp16m" />
                </span>
                <p className="text-[16px] leading-relaxed text-ink/85" data-id="element-264" data-mp="1x5zjuf38i5c9">{p.text}</p>
              </li>;
        })}
        </ul>
        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-265" data-mp="21xrccv5yal51">
          <p className="font-serif text-2xl font-bold text-navy sm:text-3xl" data-id="element-266" data-mp="26w2ojcjpx7qf">And it shouldn't have to feel so disorganized.</p>
          <p className="mt-4 text-lg leading-relaxed text-navy/75" data-id="element-267" data-mp="2awcu4o3llw4r">
            You don't need more information. You need a better way to{" "}
            <strong className="text-navy" data-id="element-268" data-mp="2fueb93hgrldl">organize the information you already have.</strong>
          </p>
        </div>
        <div className="mt-10" data-id="element-269" data-mp="lig4d86mn1kv">
          <CtaButton label="I want a structured planning system" data-id="element-270" data-mp="lj99k4pxtj0w" />
        </div>
      </div>
    </section>;
}